import PropTypes from 'prop-types';
import { useRecoilValue } from 'recoil';
import { featureFlagState } from 'state/featureFlagState';

const FeatureFlag = ({ children, inverse, name }) => {
  const featureFlags = useRecoilValue(featureFlagState);

  if (!name || !(name in featureFlags) || !children) {
    return null;
  }
  
  const valueToMatch = inverse ? false : true;

  return featureFlags[name] === valueToMatch
    ? children
    : null;
};

FeatureFlag.propTypes = {
  children: PropTypes.node.isRequired,
  inverse: PropTypes.bool,
  name: PropTypes.string.isRequired,
};

FeatureFlag.defaultProps = {
  inverse: false,  
};

export default FeatureFlag;